module.exports = __webpack_public_path__ + "img/icon-logs.9f134e8c.svg";